import { protocolTokensSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { DefiProtocolTokensPage } from "../../features/defi/pages/defi-protocol-tokens-page";

export const Route = createFileRoute("/_layout/defi/protocols/$protocolKey")({
  component: DefiProtocolTokensPage,
  validateSearch: zodValidator(protocolTokensSearchSchema),
});
